import React from 'react';

import LanguageIcon from '@material-ui/icons/Language';
import CallIcon from '@material-ui/icons/Call';

import useStyles from './styles';

function Footer() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <span className={classes.title}>2020 © GESTOR FOOD</span>
      <div className={classes.info}>
        <div className={classes.field}>
          <LanguageIcon style={{ fontSize: '1.3rem' }} />
          <span className={classes.text}>www.gestorfood.com</span>
        </div>
        <div className={classes.field}>
          <CallIcon style={{ fontSize: '1.3rem' }} />
          <span className={classes.text}>(65) 99350-6792</span>
        </div>
      </div>
    </div>
  );
}

export default Footer;
